export const normalizeTrimmedLowercase = (value?: string | null): string =>
  value?.trim().toLowerCase() ?? "";

export type NormalizeProductKeyOptions = {
  /** When true, trim before lowercasing / snake-casing (matches agreement helpers). */
  trim?: boolean;
};

/**
 * Normalize a product label to a comparable snake_case key.
 * Default (no trim) matches Opportunity Pipeline / CreditCommittee card behavior.
 */
export const normalizeProductKey = (
  product?: string | null,
  options?: NormalizeProductKeyOptions,
): string => {
  const raw = String(product || "");
  const source = options?.trim ? raw.trim() : raw;
  return source.toLowerCase().replace(/[\s-]+/g, "_");
};

export type ProductKeyIncludesOptions = NormalizeProductKeyOptions & {
  /** Optional keyword; defaults to `"reverse"` (reverse-factoring detection). */
  keyword?: string;
};

/**
 * Keyword search on a normalized product key.
 * Pass `keyword` via options when not using the default `"reverse"`.
 */
export const productKeyIncludes = (
  product?: string | null,
  options?: ProductKeyIncludesOptions,
): boolean =>
  normalizeProductKey(product, options).includes(options?.keyword ?? "reverse");
